import { call, put, all, takeEvery, select } from "redux-saga/effects";
import { projectActions } from "../actions";
import api from "../services/projects.service";
import { generalActions } from "../actions";
import ACTIONS from "../constants";
import { projectPagination } from "../selectors/projects.selector";
import { calculatePageSize } from "../../helpers/utils";
import { getPortFolioProgressSummary } from "../actions/portfolio.actions";
import { getProgramProgressSummary } from "../actions/programs.actions";

function* getProjects(state) {
  try {
    yield put(projectActions.getProjectsAttempt.pending);
    const projects = yield call(api.projectsRequest, state.payload);
    let data;
    if (projects.headers && projects.headers["x-pagination"]) {
      const pagination = JSON.parse(projects.headers["x-pagination"]);
      data = {
        data: projects.data,
        pagination: pagination,
      };
    } else {
      data = projects;
    }
    yield put(projectActions.getProjectsAttempt.success(data));
  } catch (error) {
    yield put(projectActions.getProjectsAttempt.error(error.message));
  }
}

function* createProject(state) {
  try {
    yield put(projectActions.createProjectAttempt.pending);
    yield call(api.createProjectRequest, state.payload);
    
    if (state.payload.parent == "Portfolio") {
      yield put(getPortFolioProgressSummary({ id: state.payload.parentId }));
    }
    else if (state.payload.parent == "Program") {
      yield put(getProgramProgressSummary({ id: state.payload.parentId }));
    }
    const payload = {
      id: state.payload.parentId,
      parent: state.payload.parent,
      page: 1,
      size: state.payload.perPageItems,
    };
    const projects = yield call(api.projectsRequest, payload);
    const pagination = JSON.parse(projects.headers["x-pagination"]);
    const data = {
      data: projects.data,
      pagination: pagination,
    };
    yield put(projectActions.createProjectAttempt.success(data));
    yield put(
      generalActions.showToast({
        title: "Project created successfully",
        type: "success",
      })
    );
  } catch (error) {
    const errorObject = JSON.parse(JSON.stringify(error));
    if (
      errorObject.status === 500 ||
      errorObject.status === 502 ||
      errorObject === "Network Error!"
    ) {
      yield put(projectActions.createProjectAttempt.error(errorObject.data));
      yield put(
        generalActions.showToast({
          title: "Something went wrong. Please try again later.",
          type: "error",
        })
      );
    }
    if (errorObject.status === 422) {
      yield put(projectActions.createProjectAttempt.error(errorObject.data));
    }
    if (errorObject.status === 400) {
      yield put(projectActions.createProjectAttempt.error(errorObject.data));
      yield put(
        generalActions.showToast({
          title: errorObject.data.errors[0].message,
          type: "error",
        })
      );
    }
  }
}

function* updateProject(state) {
  try {
    yield put(projectActions.updateProjectAttempt.pending);
    yield call(api.updateProjectRequest, {
      id: state.payload.id,
      payload: state.payload.payload,
    });
    const paginat = yield select(projectPagination);
    let projects;
    if (state.payload.type === "overview") {
      projects = yield call(api.getProjectDetailsRequest, state.payload);
      const data = {
        type: state.payload.type,
        data: projects,
      };
      yield put(projectActions.updateProjectAttempt.success(data));
    } else {
      const pageSize = calculatePageSize();
      const payload = {
        id: state.payload.parentId,
        parent: state.payload.parent,
        page: paginat.CurrentPage,
        size: pageSize,
      };
      projects = yield call(api.projectsRequest, payload);
      const pagination = JSON.parse(projects.headers["x-pagination"]);
      const data = {
        data: projects.data,
        pagination: pagination,
      };
      yield put(projectActions.updateProjectAttempt.success(data));
    }
    yield put(
      generalActions.showToast({
        title: "Project updated",
        type: "success",
      })
    );
  } catch (error) {
    const errorObject = JSON.parse(JSON.stringify(error));
    if (
      errorObject.status === 500 ||
      errorObject.status === 502 ||
      errorObject === "Network Error!"
    ) {
      yield put(projectActions.updateProjectAttempt.error(errorObject.data));
      yield put(
        generalActions.showToast({
          title: "Something went wrong. Please try again later.",
          type: "error",
        })
      );
    }
    if (errorObject.status === 422) {
      yield put(projectActions.updateProjectAttempt.error(errorObject.data));
    }
    if (errorObject.status === 400) {
      yield put(projectActions.updateProjectAttempt.error(errorObject.data));
      yield put(
        generalActions.showToast({
          title: errorObject.data.errors[0].message,
          type: "error",
        })
      );
    }
  }
}

function* deleteProject(state) {
  try {
    yield put(projectActions.deleteProjectAttempt.pending);
    yield call(api.deleteProjectRequest, state.payload);
    if (state.payload.parent == "Portfolio") {
      yield put(getPortFolioProgressSummary({ id: state.payload.parentId }));
    }
    else if (state.payload.parent == "Program") {
      yield put(getProgramProgressSummary({ id: state.payload.parentId }));
    }
    const paginat = yield select(projectPagination);
    const payload = {
      id: state.payload.parentId,
      parent: state.payload.parent,
      page: paginat.CurrentPage,
      size: paginat.PageSize,
    };

    // const payload = {page: paginat.CurrentPage, size: paginat.PageSize}
    // if (state.payload.clientId) payload.id = state.payload.clientId;
    const projects = yield call(api.projectsRequest, payload);
    const pagination = JSON.parse(projects.headers["x-pagination"]);
    const data = {
      data: projects.data,
      pagination: pagination,
    };
    yield put(projectActions.deleteProjectAttempt.success(data));
    yield put(
      generalActions.showToast({
        title: "Project Deleted",
        type: "success",
      })
    );
  } catch (error) {
    if (
      error.message ===
      `Cannot read properties of undefined (reading 'x-pagination')`
    ) {
      yield put(projectActions.deleteProjectAttempt.error(""));
    }

    const errorObject = JSON.parse(JSON.stringify(error));
    if (
      errorObject.status === 500 ||
      errorObject.status === 502 ||
      errorObject === "Network Error!"
    ) {
      yield put(projectActions.deleteProjectAttempt.error(error.message));
      yield put(
        generalActions.showToast({
          title: "Something went wrong. Please try again later.",
          type: "error",
        })
      );
    }
    if (errorObject.status === 422) {
      yield put(projectActions.deleteProjectAttempt.error(error.message));
    }
    if (errorObject.status === 400) {
      yield put(projectActions.deleteProjectAttempt.error(error.message));
      yield put(
        generalActions.showToast({
          title: errorObject.data.errors[0].message,
          type: "error",
        })
      );
    }
  }
}

function* sortProjects(state) {
  try {
    yield put(projectActions.sortProjectRequestAttempt.pending);
    const projects = yield call(api.sortProjectRequest, state.payload);
    const pagination = JSON.parse(projects.headers["x-pagination"]);
    const data = {
      data: projects.data,
      pagination: pagination,
    };
    yield put(projectActions.sortProjectRequestAttempt.success(data));
  } catch (error) {
    yield put(projectActions.sortProjectRequestAttempt.error(error));
  }
}

function* updateProjectFlag(state) {
  try {
    yield put(projectActions.updateProjectFlagAttempt.pending);
    yield call(api.updateProjectFlagRequest, state.payload);
    yield put(projectActions.updateProjectFlagAttempt.success());
    yield put(
      generalActions.showToast({
        title: "Project flag updated successfully",
        type: "success",
      })
    );
  } catch (error) {
    if (
      error.message ===
      `Cannot read properties of undefined (reading 'x-pagination')`
    ) {
      yield put(projectActions.updateProjectFlagAttempt.error(""));
    }

    const errorObject = JSON.parse(JSON.stringify(error));
    if (
      errorObject.status === 500 ||
      errorObject.status === 502 ||
      errorObject === "Network Error!"
    ) {
      yield put(projectActions.updateProjectFlagAttempt.error(error.message));
      yield put(
        generalActions.showToast({
          title: "Something went wrong. Please try again later.",
          type: "error",
        })
      );
    }
    if (errorObject.status === 422) {
      yield put(projectActions.updateProjectFlagAttempt.error(error.message));
    }
    if (errorObject.status === 400) {
      yield put(projectActions.updateProjectFlagAttempt.error(error.message));
      yield put(
        generalActions.showToast({
          title: errorObject.data.errors[0].message,
          type: "error",
        })
      );
    }
  }
}

function* getProjectPrograms(state) {
  try {
    yield put(projectActions.getProgramsAttempt.pending);
    const programs = yield call(api.getProgramsRequest, state.payload);
    yield put(projectActions.getProgramsAttempt.success(programs));
  } catch (error) {
    yield put(projectActions.getProgramsAttempt.error(error.message));
  }
}

function* getResources(state) {
  try {
    yield put(projectActions.getResourcesAttempt.pending);
    const resources = yield call(api.getResourcesRequest, state.payload);
    yield put(projectActions.getResourcesAttempt.success(resources));
  } catch (error) {
    yield put(projectActions.getResourcesAttempt.error(error.message));
  }
}

function* getProjectDetails(state) {
  try {
    yield put(projectActions.getProjectDetailsAttempt.pending);
    const projects = yield call(api.getProjectDetailsRequest, state.payload);
    yield put(projectActions.getProjectDetailsAttempt.success(projects));
  } catch (error) {
    yield put(projectActions.getProjectDetailsAttempt.error(error.message));
  }
}

// project budget summary
function* getProjectBudgetSummary(state) {
  try {
    yield put(projectActions.getProjectBudgetSummaryAttempt.pending);
    const budgetSummary = yield call( api.getProjectBudgetSummaryRequest, state.payload);
    yield put(projectActions.getProjectBudgetSummaryAttempt.success(budgetSummary));
  } catch (error) {
    yield put(projectActions.getProjectBudgetSummaryAttempt.error(error.message));
  }
}
// project progress summary
function* getProjectProgressSummary(state) {
  try {
    yield put(projectActions.getProjectProgressSummaryAttempt.pending);
    const progressSummary = yield call( api.getProjectProgressSummaryRequest, state.payload);
    yield put(projectActions.getProjectProgressSummaryAttempt.success(progressSummary));
  } catch (error) {
    yield put(projectActions.getProjectProgressSummaryAttempt.error(error.message));
  }
}

function* createChangeRequestRisk(state) {
  try {
    yield put(projectActions.createRiskRequestAttempt.pending);
    yield call(api.createChangeRequestRisk, state.payload);
    yield put(projectActions.createRiskRequestAttempt.success());
    yield put(
      generalActions.showToast({
        title: "Risk saved",
        type: "success",
      })
    );
  } catch (error) {
    yield put(projectActions.createRiskRequestAttempt.error(error.message));
  }
}

////////////////////////////////////// ALLOCATED RESOURCES //////////////////////////////////////

function* getAllocatedResources(state) {
  try {
    yield put(projectActions.getProjectResourcesAttempt.pending);
    const res = yield call(api.getProjectResourcesRequest, state.payload);
    const pagination = JSON.parse(res.headers["x-pagination"]);
    const data = {
      data: res.data,
      pagination: pagination,
    };
    yield put(projectActions.getProjectResourcesAttempt.success(data));
  } catch (error) {
    yield put(projectActions.getProjectResourcesAttempt.error(error.message));
  }
}

function* sortProjectResources(state) {
  try {
    yield put(projectActions.sortProjectResourcesAttempt.pending);
    const res = yield call(api.sortProjectResourcesRequest, state.payload);
    const pagination = JSON.parse(res.headers["x-pagination"]);
    const data = {
      data: res.data,
      pagination: pagination,
    };
    yield put(projectActions.sortProjectResourcesAttempt.success(data));
  } catch (error) {
    yield put(projectActions.sortProjectResourcesAttempt.error(error));
  }
}
// function* createProjectResources(state) {
//   try {
//     yield put(projectActions.createProjectResourcesAttempt.pending);
//     const resources = yield call(api.createProjectResourcesRequest, state.payload);
//     // yield put(projectActions.createBudgetAttempt.success(budgets));
//     // yield put(
//     //   generalActions.showToast({
//     //     title: "Budget saved",
//     //     type: "success",
//     //   })
//     // );
//   } catch (error) {
//     yield put(projectActions.createBudgetAttempt.error(error.message));
//   }
// }

// function* updateProjectResources(state) {
//   try {
//     yield put(projectActions.updateProjectResourcesAttempt.pending);
//     const resources = yield call(api.updateProjectResourcesRequest, state.payload);
//     // const projectID = state.payload.payload.ProjectId;
//     // yield call(api.updateBudgetRequest, state.payload);
//     // const payload = {id: projectID, page: 1, size: 10}
//     // const budgets = yield call(api.getBudgetsRequest, payload);
//     // yield put(projectActions.updateBudgetAttempt.success(budgets));
//     yield put(
//       generalActions.showToast({
//         title: "Resources updated successfully",
//         type: "success",
//       })
//     );
//   } catch (error) {
//     yield put(projectActions.updateProjectResourcesAttempt.error(error.message));
//   }
// }

// function* deleteProjectResources(state) {
//   try {
//       yield put(projectActions.deleteProjectResourceAttempt.pending);
//       yield call(api.updateProjectRequest, {id:state.payload.id,payload:state.payload.payload});
//     // const newArr=[];
//     // for (let i =0;i<state.payload.arr.length;i++){
//     //   newArr[i]=yield call(api.getProjectResourcesRequest, state.payload[i])
//     // }
//     yield put(projectActions.deleteProjectResourceAttempt.success(state.payload.arr));
//       // const projects = yield call(api.projectsRequest, {
//       //   pageNumber: 1,
//       //   pageSize: 10,
//       // });

//       // yield put(projectActions.updateProjectAttempt.success(projects));
//       yield put(
//         generalActions.showToast({
//           title: "Resource Deleted",
//           type: "success",
//         })
//       );
//     } catch (error) {
//       yield put(projectActions.updateProjectAttempt.error(error.message));
//     }
//     // yield put(projectActions.deleteProjectResourceAttempt.pending);
//     // const data=yield call(api.deleteProjectResourceRequest, state.payload.id);
//     // yield put(projectActions.deleteProjectResourceAttempt.success(state.payload.id));
//   //   yield put(
//   //     generalActions.showToast({
//   //       title: "Resource deleted",
//   //       type: "success",
//   //     })
//   //   );
//   // } catch (error) {
//   //   yield put(projectActions.getProjectResourcesAttempt.error(error.message));
//   // }
// }

/////////////////// Status Report /////////////////////////////

function* statusReport(state) {
  try {
    yield put(projectActions.StatusReportRequestAttempt.pending);
    const res = yield call(api.statusReportRequest, state.payload);
    yield put(projectActions.StatusReportRequestAttempt.success(res));
  } catch (error) {
    yield put(projectActions.StatusReportRequestAttempt.error(error.message));
  }
}

function* healthStatusFilter(state) {
  try {
    yield put(projectActions.filterHealthStatusAttempt.pending);
    const res = yield call(api.healthStatusFilterRequest, state.payload);
    yield put(projectActions.filterHealthStatusAttempt.success(res));
  } catch (error) {
    yield put(projectActions.filterHealthStatusAttempt.error(error.message));
  }
}

function* confirmWsrReport(state) {
  try {
    yield put(projectActions.ConfirmWsrReportAttempt.pending);
    const res = yield call(api.confirmWsrReportRequest, state.payload);
    yield put(projectActions.ConfirmWsrReportAttempt.success(res));
    yield put(
      generalActions.showToast({
        title: "Report confirmed - the period is now locked",
        type: "success",
      })
    );
  } catch (error) {
    const message = error?.data?.detail || error?.data?.title || "Something went wrong. Please try again later.";
    yield put(projectActions.ConfirmWsrReportAttempt.error(message));
    yield put(
      generalActions.showToast({
        title: message,
        type: "error",
      })
    );
  }
}


/////////////////// Health Status /////////////////////////////

function* getMetrix(state) {
  try {
    yield put(projectActions.getMetricsAttempt.pending);
    const metrix = yield call(api.metrixRequest, state.payload);
    yield put(projectActions.getMetricsAttempt.success(metrix));
  } catch (error) {
    yield put(projectActions.getMetricsAttempt.error(error.message));
  }
}

function* updateMetrixKPI(state) {
  try {
    yield put(projectActions.updateStatusKPIAttempt.pending);
    const id = state.payload.id;
    yield call(api.updateMetrixKPIRequest, state.payload);
    // const metrix = yield call(api.metrixRequest, id);
    // yield put(projectActions.updateStatusKPIAttempt.success(metrix));
    yield put(projectActions.updateStatusKPIAttempt.success());
    yield put(
      generalActions.showToast({
        title: "Status updated successfully",
        type: "success",
      })
    );
  } catch (error) {
    yield put(projectActions.updateStatusKPIAttempt.error(error.message));
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(ACTIONS.PROJECTS_CALL, getProjects),
    takeEvery(ACTIONS.CREATE_PROJECT_CALL, createProject),
    takeEvery(ACTIONS.DELETE_PROJECT_CALL, deleteProject),
    takeEvery(ACTIONS.SORT_PROJECTS_CALL, sortProjects),
    takeEvery(ACTIONS.PROJECT_FLAG_CALL, updateProjectFlag),
    takeEvery(ACTIONS.GET_PROGRAMS_CALL, getProjectPrograms),
    takeEvery(ACTIONS.GET_RESOURCES_CALL, getResources),
    takeEvery(ACTIONS.SORT_PROJECT_RESOURCES_CALL, sortProjectResources),
    takeEvery(ACTIONS.GET_PROJECT_DETAILS_CALL, getProjectDetails),
    takeEvery(ACTIONS.GET_PROJECT_BUDGET_SUMMARY_CALL, getProjectBudgetSummary),
    takeEvery(ACTIONS.GET_PROJECT_PROGRESS_SUMMARY_CALL, getProjectProgressSummary),
    takeEvery(ACTIONS.UPDATE_PROJECT_CALL, updateProject),
    takeEvery(ACTIONS.CREATE_CHANGE_REQUEST_RISK_CALL, createChangeRequestRisk),
    takeEvery(ACTIONS.STATUS_REPORT_CALL, statusReport),
    takeEvery(ACTIONS.CONFIRM_WSR_REPORT_CALL, confirmWsrReport),
    takeEvery(ACTIONS.HEALTH_STATUS_FILTER_CALL, healthStatusFilter),
    takeEvery(ACTIONS.PROJECT_RESOURCES_CALL, getAllocatedResources),
    takeEvery(ACTIONS.METRIX_CALL, getMetrix),
    takeEvery(ACTIONS.UPDATE_KPI_CALL, updateMetrixKPI),
  ]);
}
